import React from 'react';
import styled from '@emotion/styled';
import { ThemeProvider } from 'emotion-theming';
import { themeGet } from '@styled-system/theme-get';
import SendGridLink from '../components/SendGridLink';
import Theme from '../components/Theme';
import illustration404Svg from '../assets/images/404/404-illustration.svg';

const Styled404Containter = styled.div`
  ${themeGet('font.whitneyBook')}
  position: relative;
  margin: ${themeGet('scale.scaleUp08')} auto ${themeGet('scale.scaleUp05')};
  padding: 0 ${themeGet('scale.scaleUp02')};
  text-align: center;

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    position: absolute;
    top: ${themeGet('scale.scaleUp08')};
    left: 50%;
    max-width: 480px;
    margin-left: -240px;
    padding: 0;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointDesktop')}) {
    top: ${themeGet('scale.scaleUp15')};
  }
`;

const Styled404Image = styled.img`
  display: block;
  margin: ${themeGet('scale.scaleUp05')} auto;
`;

const NotFoundPage = () => (
  <ThemeProvider theme={{ ...Theme }}>
    <div className="site-wrapper">
      <Styled404Containter>
        <h1>Ouch!</h1>
        <p className="m-bottom-4 is-size-24">
          It hurts to admit, but the page
          {" you're "}
          looking for
          {" can't "}
          be found.
        </p>
        <SendGridLink to="/">Return Home</SendGridLink>
      </Styled404Containter>
      <Styled404Image src={illustration404Svg} alt="404" />
    </div> {/* <div>test bulid pipeline</div> */}
  </ThemeProvider>
);

export default NotFoundPage;
